'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var reactContext = require('@chakra-ui/react-context');
var react = require('@chakra-ui/react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _createContext = reactContext.createContext({
    name: 'DateTimeFieldContext',
    hookName: 'useDateTimeField',
    providerName: '<DateField /> or <TimeField />'
  }),
  _createContext2 = _slicedToArray__default["default"](_createContext, 2),
  DateTimeFieldProvider = _createContext2[0],
  useDateTimeFieldContext = _createContext2[1];
var _createStylesContext = react.createStylesContext('DateField'),
  _createStylesContext2 = _slicedToArray__default["default"](_createStylesContext, 2),
  DateTimeFieldStylesProvider = _createStylesContext2[0],
  useDateTimeFieldStyles = _createStylesContext2[1];
exports.DateTimeFieldProvider = DateTimeFieldProvider;
exports.DateTimeFieldStylesProvider = DateTimeFieldStylesProvider;
exports.useDateTimeFieldContext = useDateTimeFieldContext;
exports.useDateTimeFieldStyles = useDateTimeFieldStyles;